// 画面表示テキストから読み上げテキストへの変換
// (spec: docs/superpowers/specs/2026-07-26-prerendered-tts-design.md §9.1)。
//
// 鉤括弧 (「」) は画面表示では「何と答えればよいか」を一目で示す手がかりとして必要だが、
// ElevenLabs に渡すと抑揚が崩れることが実機聴取で確認された (2026-07-26)。
// 表示テキストはそのまま保ち、読み上げ (TTS 合成) に渡す直前だけこの変換を通す。
//
// 鉤括弧の除去に加えて、読みが直らなかった語だけを個別に読み替える
// (spec §9 の「直らない語が出てから拡張する」に沿った 2 件目のルール)。
//
// 読み替えは「実機で聴いて直らなかった語」だけを列挙する。数字を機械的に読み仮名へ
// 変換してはならない — 読みが後続語で変わるため (5 分 = ごふん / 5 問 = ごもん /
// 5 つ = いつつ)。列挙を増やすときも、聴取で確認した語だけを足すこと。
//
// **まず文言側で直せないかを先に見る**。この表は表示と読みの要求が食い違うとき
// (「5 つ」を画面に「いつつ」と出せない) の最後の手段で、言い換えが効くならそちらが
// 優れている — 表が増えるほど画面と読みの対応が追いにくくなるため。2026-08-04 の
// 「姓と名前」(「しょう」と読まれた) は、読み替えではなく ttsPhrases 側を「苗字と名前」に
// 変えて解決した (spec §9.2.1)。
//
// 表示テキスト側を変えない (「いつつほど」と画面に出さない) のは、業務アンケートの
// 案内としてひらがな表記が幼く見えるため。「お手数」を語ごと落とした判断 (2026-07-26、
// ttsPhrases.ts の errorSttFailed) と同じ理由で、画面と読みを分ける方に倒している。
const READING_OVERRIDES: ReadonlyArray<readonly [RegExp, string]> = [
  // 「5 つ」が正しく読まれない (2026-08-04 実機聴取)。チュートリアル冒頭と本編の挨拶の
  // 2 文言に出る。表記ゆれを吸収するため数字と「つ」の間の空白は任意にしている。
  [/5\s*つ/g, "いつつ"],
];

export function toSpeechText(text: string): string {
  let out = text.replace(/[「」]/g, "");
  for (const [pattern, reading] of READING_OVERRIDES) {
    out = out.replace(pattern, reading);
  }
  return out;
}
